import { calcularConsumoKwh } from "./CalcularConsumoKWH";
import { isValidTipoConta } from "./IsValidTipoConta";

/**
 * Para ser possível filtrar planos contratáveis com base no "consumoDinheiro", precisa ter populado usina e em usina, concessionária nos planoUsinas
 */
export async function filtrarPlanoUsinasContrataveis({ 
  planoUsinas, 
  consumoDinheiro, 
  tipoConta, // PJ ou PF
  concessionariaId, // Quando for necessário modificar relacionamento entre concessionária e usina, many to many, esse campo será necessário 
}) {
  
  if(planoUsinas.length < 1) {
    return [];
  }

  if(!isValidTipoConta(tipoConta)) {
    return [];
  }

  const concessionaria = getConcessionaria({ planoUsina: planoUsinas[0], concessionariaId });

  if(!concessionaria) {
    return [];
  }

  const valorKwh = concessionaria.attributes[`valor_kwh_${tipoConta}`];


  const consumoKwh = calcularConsumoKwh({
    consumoDinheiro: Number(consumoDinheiro),
    valorKwh
  });

  return planoUsinas.filter(
    planoUsina => 
        !(planoUsina.attributes?.[`consumo_minimo_kw_${tipoConta}`] > consumoKwh) // consumo precisa ser compatível
      && 
        planoUsina.attributes?.contrato_plano_usinas?.data?.length > 0// para ser contratável, precisa haver ao menos um contrato_plano_usina
  )
}

// Retorna a concessionária contida no plano
function getConcessionaria({ planoUsina, concessionariaId }) {
  // Quando modificar relacionamento concessionaria <> usina para manyToMany, trabalhar concessionariaId
  return planoUsina.attributes?.usina?.data?.attributes?.concessionaria?.data ?? null;
}